import { ORDER_STATUS } from './order';
import { ORDER_DELIVERY_TYPES } from '~/constants/deliveryTypes';

export enum AGGREGATORS {
  JAHEEZ = 1,
  CAREEM = 2,
  DOOK = 3,
  MINI_DOOK = 4,
  HUNGER_STATION = 15,
  TO_YOU = 20,
  KEETA = 21,
}

export enum DOOK_TENANT_TYPES {
  MAIN_DOOK = 0,
  EXTERNAL_DOOK = 1,
  MINI_DOOK = 2,
}

export const AGGREGATOR_NAMES: Record<AGGREGATORS, string> = {
  [AGGREGATORS.JAHEEZ]: 'Jahez',
  [AGGREGATORS.HUNGER_STATION]: 'HungerStation',
  [AGGREGATORS.TO_YOU]: 'ToYou',
  [AGGREGATORS.KEETA]: 'Keeta',
  [AGGREGATORS.CAREEM]: 'Careem',
  [AGGREGATORS.DOOK]: 'Dook',
  [AGGREGATORS.MINI_DOOK]: 'Mini Aggregator',
};

export const OVERRIDE_ORDER_OPTIONS: {
  [key: string]: { [key: string]: string | null };
} = {
  [AGGREGATORS.JAHEEZ]: {
    paymentMethod: AGGREGATOR_NAMES[AGGREGATORS.JAHEEZ],
    paymentMethodIcon: null,
  },
  [AGGREGATORS.CAREEM]: {
    paymentMethod: AGGREGATOR_NAMES[AGGREGATORS.CAREEM],
    paymentMethodIcon: null,
  },
  [AGGREGATORS.HUNGER_STATION]: {
    paymentMethod: AGGREGATOR_NAMES[AGGREGATORS.HUNGER_STATION],
    paymentMethodIcon: null,
  },
  [AGGREGATORS.TO_YOU]: {
    paymentMethod: AGGREGATOR_NAMES[AGGREGATORS.TO_YOU],
    paymentMethodIcon: null,
  },
  [AGGREGATORS.KEETA]: {
    paymentMethod: AGGREGATOR_NAMES[AGGREGATORS.KEETA],
    paymentMethodIcon: null,
  },
};

export const AGGREGATOR_ORDER_SCHEME: {
  [key: string]: { [key: string]: any };
} = {
  [AGGREGATORS.JAHEEZ]: {
    statusManagment: {
      [ORDER_STATUS.PENDING]: {
        [ORDER_DELIVERY_TYPES.DELIVERY]: [ORDER_STATUS.ACCEPTED, ORDER_STATUS.CANCELED],
      },
    },
    statusSwitchButtonSteps: {
      [ORDER_STATUS.PENDING]: {
        [ORDER_DELIVERY_TYPES.DELIVERY]: ORDER_STATUS.ACCEPTED,
      },
    },
    phone: true,
    delivery: false,
    payment_type: true,
    vat: false,
    vat_delivery_fee: false,
    discount: false,
    cashback: false,
    edit: true,
    dsp_status: true,
    due_time: true,
    customer: true,
    payment_method: true,
    delivery_managment: true,
    delivery_recipient: true,
    export: false,
    healthcheck: true,
    transaction_logs: false,
  },
  [AGGREGATORS.CAREEM]: {
    statusManagment: {
      [ORDER_STATUS.PENDING]: {
        [ORDER_DELIVERY_TYPES.DELIVERY]: [ORDER_STATUS.ACCEPTED, ORDER_STATUS.CANCELED],
      },
    },
    statusSwitchButtonSteps: {
      [ORDER_STATUS.PENDING]: {
        [ORDER_DELIVERY_TYPES.DELIVERY]: ORDER_STATUS.ACCEPTED,
      },
    },
    phone: true,
    delivery: false,
    payment_type: true,
    vat: false,
    vat_delivery_fee: false,
    discount: false,
    cashback: false,
    edit: true,
    dsp_status: true,
    due_time: true,
    customer: true,
    payment_method: true,
    delivery_managment: true,
    delivery_recipient: true,
    export: false,
    healthcheck: true,
    transaction_logs: false,
  },
  [AGGREGATORS.HUNGER_STATION]: {
    statusManagment: {
      [ORDER_STATUS.ACCEPTED]: {
        [ORDER_DELIVERY_TYPES.DELIVERY]: [ORDER_STATUS.CANCELED, ORDER_STATUS.WAITING_FOR_PICKUP],
        [ORDER_DELIVERY_TYPES.PICKUP]: [ORDER_STATUS.CANCELED, ORDER_STATUS.WAITING_FOR_PICKUP],
      },
      [ORDER_STATUS.WAITING_FOR_PICKUP]: {
        [ORDER_DELIVERY_TYPES.PICKUP]: [ORDER_STATUS.CANCELED, ORDER_STATUS.COMPLETED],
      },
    },
    statusSwitchButtonSteps: {
      [ORDER_STATUS.ACCEPTED]: {
        [ORDER_DELIVERY_TYPES.DELIVERY]: ORDER_STATUS.WAITING_FOR_PICKUP,
        [ORDER_DELIVERY_TYPES.PICKUP]: ORDER_STATUS.WAITING_FOR_PICKUP,
      },
      [ORDER_STATUS.WAITING_FOR_PICKUP]: {
        [ORDER_DELIVERY_TYPES.PICKUP]: ORDER_STATUS.COMPLETED,
      },
    },
    phone: true,
    delivery: false,
    payment_type: true,
    vat: false,
    vat_delivery_fee: false,
    discount: false,
    cashback: false,
    edit: true,
    dsp_status: true,
    due_time: true,
    customer: true,
    payment_method: true,
    delivery_managment: true,
    delivery_recipient: true,
    export: false,
    healthcheck: true,
    transaction_logs: false,
  },
  [AGGREGATORS.DOOK]: {
    statusManagment: undefined,
    phone: false,
    delivery: false,
    payment_type: false,
    vat: false,
    vat_delivery_fee: false,
    discount: false,
    cashback: false,
    edit: true,
    dsp_status: false,
    due_time: false,
    customer: false,
    payment_method: false,
    delivery_managment: false,
    delivery_recipient: false,
    export: false,
    healthcheck: false,
    transaction_logs: true,
  },
  [AGGREGATORS.TO_YOU]: {
    statusManagment: {
      [ORDER_STATUS.ACCEPTED]: {
        [ORDER_DELIVERY_TYPES.DELIVERY]: [ORDER_STATUS.CANCELED],
        [ORDER_DELIVERY_TYPES.PICKUP]: [ORDER_STATUS.CANCELED],
      },
    },
    phone: true,
    delivery: false,
    payment_type: true,
    vat: false,
    vat_delivery_fee: false,
    discount: false,
    cashback: false,
    edit: true,
    dsp_status: true,
    due_time: true,
    customer: true,
    payment_method: true,
    delivery_managment: true,
    delivery_recipient: true,
    export: false,
    healthcheck: true,
    transaction_logs: false,
  },
  [AGGREGATORS.KEETA]: {
    statusManagment: {
      [ORDER_STATUS.PENDING]: {
        [ORDER_DELIVERY_TYPES.DELIVERY]: [ORDER_STATUS.ACCEPTED, ORDER_STATUS.CANCELED],
        [ORDER_DELIVERY_TYPES.PICKUP]: [ORDER_STATUS.ACCEPTED, ORDER_STATUS.CANCELED],
      },
      [ORDER_STATUS.ACCEPTED]: {
        [ORDER_DELIVERY_TYPES.DELIVERY]: [ORDER_STATUS.WAITING_FOR_PICKUP],
        [ORDER_DELIVERY_TYPES.PICKUP]: [ORDER_STATUS.WAITING_FOR_PICKUP],
      },
    },
    statusSwitchButtonSteps: {
      [ORDER_STATUS.PENDING]: {
        [ORDER_DELIVERY_TYPES.DELIVERY]: ORDER_STATUS.ACCEPTED,
        [ORDER_DELIVERY_TYPES.PICKUP]: ORDER_STATUS.ACCEPTED,
      },
      [ORDER_STATUS.ACCEPTED]: {
        [ORDER_DELIVERY_TYPES.DELIVERY]: ORDER_STATUS.WAITING_FOR_PICKUP,
        [ORDER_DELIVERY_TYPES.PICKUP]: ORDER_STATUS.WAITING_FOR_PICKUP,
      },
    },
    phone: true,
    delivery: false,
    payment_type: true,
    vat: false,
    vat_delivery_fee: false,
    discount: false,
    cashback: false,
    edit: true,
    dsp_status: true,
    due_time: true,
    customer: true,
    payment_method: true,
    delivery_managment: true,
    delivery_recipient: true,
    export: false,
    healthcheck: true,
    transaction_logs: false,
  },
};
